import React from 'react';
import { Box } from '@mui/material';
import { TrainingInsights } from './types';
import ObjFaqHandlingSection from './sections/ObjFaqHandlingSection';
import LandmineHandlingSection from './sections/LandmineHandlingSection';
import CompetitorHandlingSection from './sections/CompetitorHandlingSection';
import PlaybookCoverageSection from './sections/PlaybookCoverageSection';
import KbItemProgressionSection from './sections/KbItemProgressionSection';
import ToneAnalysisSection from './sections/ToneAnalysisSection';

interface Props {
  insights: TrainingInsights;
  /** Jump the session's conversation timeline to an ISO timestamp. */
  onNavigateToTimestamp?: (timestampIso: string) => void;
}

/**
 * Details sub-tab: per-section deep-dive of every dimension. Each section
 * mirrors the visual treatment used by the corresponding adherence section
 * in admin-portal/src/components/adherence/ but reads from the camelCase
 * training schema (see ./types.ts).
 */
const TrainingInsightsDetails: React.FC<Props> = ({ insights, onNavigateToTimestamp }) => (
  <Box>
    {insights.objectionFaqHandling && (
      <ObjFaqHandlingSection
        data={insights.objectionFaqHandling}
        onNavigateToTimestamp={onNavigateToTimestamp}
      />
    )}
    {insights.landmineHandling && (
      <LandmineHandlingSection
        data={insights.landmineHandling}
        onNavigateToTimestamp={onNavigateToTimestamp}
      />
    )}
    {insights.competitorHandling && (
      <CompetitorHandlingSection
        data={insights.competitorHandling}
        onNavigateToTimestamp={onNavigateToTimestamp}
      />
    )}
    {insights.playbookCoverage && (
      <PlaybookCoverageSection data={insights.playbookCoverage} />
    )}
    {insights.salesIntelligence && (
      <KbItemProgressionSection data={insights.salesIntelligence} />
    )}
    {insights.toneAnalysis && (
      <ToneAnalysisSection data={insights.toneAnalysis} />
    )}
  </Box>
);

export default TrainingInsightsDetails;
